export default __webpack_public_path__ + "static/media/halfFilledIcon.1b394bb4.svg";